import React from 'react';

export const QuestionarioCasasStepFour = ({
  formData,
  handleChange,
  timeOptions,
  selectedFiles,
  clearSelectedFiles,
  fileInputRef,
  handleFileSelection,
  formatFileSize,
}) => {
  return (
    <div className="space-y-4" data-testid="questionario-casas-step-4">
      <select name="attendancePreference" value={formData.attendancePreference} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-attendance-preference-select">
        <option value="">Preferência de atendimento *</option>
        <option value="loja">Na imobiliária / escritório</option>
        <option value="video">Via videochamada</option>
        <option value="domicilio">Atendimento no local</option>
      </select>

      <div className="border rounded-xl p-4 bg-gray-50" data-testid="questionario-casas-first-slot-container">
        <p className="font-medium mb-3">1ª data e horário preferidos *</p>
        <div className="grid sm:grid-cols-2 gap-3">
          <input type="date" name="firstPreferredDate" value={formData.firstPreferredDate} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg" data-testid="questionario-casas-first-preferred-date-input" />
          <select name="firstPreferredTime" value={formData.firstPreferredTime} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg" data-testid="questionario-casas-first-preferred-time-select">
            <option value="">Horário</option>
            {timeOptions.map((time) => (
              <option key={time} value={time}>{time}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="border rounded-xl p-4" data-testid="questionario-casas-second-slot-container">
        <p className="font-medium mb-3">2ª data e horário preferidos (opcional)</p>
        <div className="grid sm:grid-cols-2 gap-3">
          <input type="date" name="secondPreferredDate" value={formData.secondPreferredDate} onChange={handleChange} className="w-full px-4 py-3 border rounded-lg" data-testid="questionario-casas-second-preferred-date-input" />
          <select name="secondPreferredTime" value={formData.secondPreferredTime} onChange={handleChange} className="w-full px-4 py-3 border rounded-lg" data-testid="questionario-casas-second-preferred-time-select">
            <option value="">Horário</option>
            {timeOptions.map((time) => (
              <option key={time} value={time}>{time}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="border rounded-xl p-4 bg-slate-50" data-testid="questionario-casas-attachments-section">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-3">
          <div>
            <p className="font-medium text-gray-900" data-testid="questionario-casas-attachments-label">Anexos opcionais</p>
            <p className="text-sm text-gray-500" data-testid="questionario-casas-attachments-help">Envie vários arquivos de referência. Limite atual: até 10 arquivos de 15MB cada.</p>
          </div>
          {selectedFiles.length > 0 && (
            <button type="button" onClick={clearSelectedFiles} className="px-4 py-2 text-sm border border-slate-300 rounded-lg hover:bg-white transition" data-testid="questionario-casas-clear-attachments-button">
              Limpar anexos
            </button>
          )}
        </div>

        <input ref={fileInputRef} type="file" multiple onChange={handleFileSelection} className="block w-full text-sm text-slate-600 file:mr-4 file:rounded-full file:border-0 file:bg-blue-600 file:px-4 file:py-2 file:text-sm file:font-medium file:text-white hover:file:bg-blue-700" data-testid="questionario-casas-attachments-input" />

        {selectedFiles.length > 0 ? (
          <div className="mt-4 space-y-2" data-testid="questionario-casas-attachments-list">
            {selectedFiles.map((file, index) => (
              <div key={`${file.name}-${index}`} className="flex items-center justify-between gap-3 rounded-lg bg-white border border-slate-200 px-3 py-2 text-sm" data-testid={`questionario-casas-attachment-item-${index}`}>
                <span className="truncate text-slate-700">{file.name}</span>
                <span className="shrink-0 text-slate-500">{formatFileSize(file.size)}</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="mt-3 text-sm text-slate-500" data-testid="questionario-casas-attachments-empty">Nenhum arquivo selecionado.</p>
        )}
      </div>

      <textarea name="notes" value={formData.notes} onChange={handleChange} rows={4} placeholder="Observações adicionais" className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 resize-none" data-testid="questionario-casas-notes-textarea" />

      <label className="flex items-start gap-3 text-sm text-gray-700" data-testid="questionario-casas-privacy-consent-label">
        <input type="checkbox" name="privacyAccepted" checked={formData.privacyAccepted} onChange={handleChange} className="mt-1" data-testid="questionario-casas-privacy-consent-checkbox" />
        <span>Li e concordo com a política de privacidade e autorizo o contato da equipe RH Holdings. *</span>
      </label>
    </div>
  );
};
